
const links = {
  pt: {
    whatsapp:
      '<a href=\'https://www.facebook.com/business/help/447934475640650?id=371525583593535s\' target=\'_blank\' rel=\'noopener noreferrer\'>anúncios de clique para o WhatsApp</a>',
    facebook:
      '<a href=\'https://www.facebook.com/help/1638565256396310\' target=\'_blank\' rel=\'noopener noreferrer\'>botões da Página do Facebook</a>',
  },
  en: {
    whatsapp:
      '<a href=\'https://www.facebook.com/business/help/447934475640650?id=371525583593535s\' target=\'_blank\' rel=\'noopener noreferrer\'>Ads that click to WhatsApp</a>',
    facebook:
      '<a href=\'https://www.facebook.com/help/1638565256396310\' target=\'_blank\' rel=\'noopener noreferrer\'>Facebook Page buttons</a>',
  },
  es: {
    whatsapp:
      '<a href=\'https://www.facebook.com/business/help/447934475640650?id=371525583593535s\' target=\'_blank\' rel=\'noopener noreferrer\'>anuncios de clic a WhatsApp</a>',
    facebook:
      '<a href=\'https://www.facebook.com/help/1638565256396310\' target=\'_blank\' rel=\'noopener noreferrer\'>botones de la página de Facebook</a>',
  },
};

export const whatsappConversationModalContent = {
  pt: {
    locale: 'pt-BR',
    delivered: {
      title: 'Mensagens entregues',
      description: 'Número de mensagens que sua empresa enviou para contas individuais e que foram entregues com sucesso.  Essa métrica contabiliza apenas <strong>as mensagens que chegaram ao dispositivo do destinatário e exclui as mensagens que não foram entregues</strong>, por exemplo, quando o dispositivo do destinatário estava fora de serviço.',
    },
    paids: {
      title: 'Mensagens pagas entregues',
      description: 'Número de mensagens pagas <strong>entregues com sucesso a conta individuais do WhatsApp</strong>. Uma mensagem entregue significa que uma mensagem da empresa foi entregue a alguém no WhatsApp. A mensagem pode ser de marketing, utilidade, autenticação ou serviço.<br></br>',
    },
    free: {
      title: 'Mensagens gratuitas entregues',
      description: 'As mensagens entregues são consideradas <strong>gratuitas</strong> quando se enquadram na janela de atendimento ao cliente de <strong>24 horas</strong> ou na janela de ponto de entrada gratuito de <strong>72 horas</strong>.',
      calculation: `
      <p>Como o cálculo é feito:</p>    
      <ul>
        <li>A janela de atendimento ao cliente de 24 horas começa sempre que alguém envia uma mensagem à sua empresa no WhatsApp.</li>
        <li>Uma janela de atendimento ao cliente com ponto de entrada gratuito fica aberta por 72 horas e começa quando um cliente que usa dispositivo Android ou iOS envia uma mensagem a você de ${links.pt.whatsapp} ou ${links.pt.facebook} e você responde em até 24 horas.</li>
      </ul> `,
    },
    entryPoint: {
      title: 'Pontos de entrada gratuitos',
      description: 'Número de mensagens de <strong>atendimento</strong> e <strong>utilidade</strong> que sua empresa envia no WhatsApp e que são entregues dentro da janela de atendimento ao cliente de 24 horas. A janela de atendimento ao cliente começa sempre que uma conta individual do WhatsApp envia uma mensagem à sua empresa no WhatsApp. <br></br>',
    },
    service: {
      title: 'Atendimento ao cliente grátis',
      description: `Número de mensagens entregues no WhatsApp que são gratuitas porque a mensagem começa em pontos de entrada gratuitos. Uma janela de atendimento ao cliente com ponto de entrada gratuito fica aberta por 72 horas e começa quando um cliente que usa dispositivo Android ou iOS envia uma mensagem a você de ${links.pt.whatsapp} ou ${links.pt.facebook} e você responde em até 24 horas.<br>`,
    },
  },
  en: {
    locale: 'en-US',
    delivered: {
      title: 'Messages deliveried',
      description:
        'The number of messages your business sent to individual accounts or members of a WhatsApp group that were successfully delivered. This metric only counts <strong>messages that reached the recipient\'s device and excludes messages that were not delivered</strong>, such as when the recipient\'s device was out of service.',
    },
    paids: {
      title: 'Paid Messages',
      description:
        'The number of paid messages successfully delivered to individual WhatsApp accounts or members of a WhatsApp group. A message delivered is when a message from the business is delivered to someone on WhatsApp. The message can be marketing, utility, authentication or service.<br></br>',
    },
    free: {
      title: 'Messages deliveried',
      description:
        'Messages delivered are considered <strong>free</strong> if they fall within the <strong>24-hour</strong> customer service window or the <strong>72-hour</strong> free entry point window.',
      calculation: `
        <p>How it's calculated:</p>
        <ul>
            <li>The 24-hour customer service window begins whenever someone sends your business a message on WhatsApp.</li>
            <li>A free entry point customer service window is open for 72 hours and begins when a customer using an Android or iOS device sends you a message from ${links.en.whatsapp} or ${links.en.facebook} and you respond to them within 24 hours.</li>
        </ul> `,
    },
    service: {
      title: 'Free customer service',
      description:
      `The number of messages delivered on WhatsApp that are free of charge because the messaging begins from specific free entry points. A free entry point customer service window is open for 72 hours and begins when a customer using an Android or iOS device sends you a message from ${links.en.whatsapp} or ${links.en.facebook} and you respond to them within 24 hours.<br>`,
    },
    entryPoint: {
      title: 'Free entry points',
      description: 'The number of <strong>service</strong> and <strong>utility</strong> messages your business sends on WhatsApp that are delivered within the 24-hour customer service window. The customer service window begins whenever an individual WhatsApp account sends your business a message on WhatsApp.<br>',
    },
  },
  es : {
    locale: 'es-ES',
    delivered: {
      title: 'Mensajes entregados',
      description:
        'Número de mensajes que tu negocio envió a cuentas individuales o miembros de un grupo de WhatsApp, y se entregaron correctamente. Esta métrica cuenta únicamente <strong>los mensajes que llegaron al dispositivo del destinatario y excluye los mensajes que no se entregaron</strong>, por ejemplo, si el dispositivo del destinatario no tenía servicio.',
    },
    paids: {
      title: 'Mensagens pagas entregues',
      description:
        'Número de mensajes pagados entregados con éxito a cuentas individuales de WhatsApp. Un mensaje entregado significa que un mensaje de la empresa llegó a un usuario de WhatsApp. El mensaje puede ser de marketing, utilidad, autenticación o servicio.<br></br>',
    },
    free: {
      title: 'Mensajes gratuitos entregados',
      description:
        'Los mensajes entregados se consideran <strong>gratuitos</strong> si se envían durante el intervalo de atención al cliente de <strong>24 horas</strong> o el intervalo de <strong>72 horas</strong> de los puntos de acceso gratuitos.',
      calculation: `
        <p>Cómo se calcula:</p>
        <ul>
            <li>El intervalo de atención al cliente de 24 horas comienza cuando alguien le envía un mensaje a tu negocio en WhatsApp.</li>
            <li>El intervalo de servicio de atención al cliente de los puntos de acceso gratuitos se abre por 72 horas cuando un cliente con un dispositivo con Android o iOS te envía un mensaje desde ${links.es.whatsapp} o ${links.es.facebook}, y le respondes en menos de 24 horas.</li>
        </ul> `,
    },
    service: {
      title: 'Atencion al cliente gratuita',
      description: `Número de mensajes entregados en WhatsApp que son gratuitos porque se iniciaron desde puntos de acceso gratuitos específicos. El intervalo del servicio de atención al cliente de los puntos de acceso gratuitos se abre por 72 horas cuando un cliente con un dispositivo con Android o iOS te envía un mensaje desde ${links.es.whatsapp} o ${links.es.facebook}, y le respondes en menos de 24 horas.<br>`,
    },
    entryPoint: {
      title: 'Punto de acceso gratuito',
      description:
        'Número de mensajes de <strong>servicio</strong> y <strong>utilidad</strong> que envía tu negocio en WhatsApp en el intervalo de atención al cliente de 24 horas. El intervalo de atención al cliente comienza cuando una cuenta individual de WhatsApp le envía a tu negocio un mensaje en WhatsApp.<br>',
    },
  },
};